import { FC, useCallback, useMemo, useState } from "react";
import { CardRender } from "../../../../../../../shared/components/CardRender";
import { formattedPercentage, renderCurrency } from "../../../../../../../shared/utils";
import { Checkbox } from "antd";
import dayjs from "dayjs";
import { ENDORSEMENTS_TYPES_VALUES, EndorsementsTypesValues } from "../../../../shared/enums/endorsements-types-values-enum";
import { ComponentEndorsements } from "../../../../../../../shared/interfaces/services/endorsement-list-service";

interface EndorsementsCardProps {
    keyCard: number;
    type: EndorsementsTypesValues;
    componentEndorsement: ComponentEndorsements;
    loading?: boolean;
    onSelectionChange: (componentElevatorsAndBoilers: ComponentEndorsements, isSelected: boolean) => void;
}

export const EndorsementsCard: FC<EndorsementsCardProps> = ({
    keyCard,
    componentEndorsement,
    loading,
    onSelectionChange,
    type
}) => {
    const [selected, setSelected] = useState(false);

    const {
        poliza,
        numeroComponente,
        sumaAseguradaActualCalderas,
        sumaAseguradaNuevaCalderas,
        sumaAseguradaActualAscensores,
        sumaAseguradaNuevaAscensores,
        prima,
        premio,
        comision,
        nombreAsegurado,
        finVigencia,

        nroPoliza,
        nroComponente,
        marca,
        modelo,
        anio,
        sumaActual,
        sumaInfoAuto,
        diferenciaMonto,
        diferenciaPorcentaje,
        proximoVencimiento,
    } = componentEndorsement;

    
    const handleCheckboxChange = () => {
        const newSelectedState = !selected;
        setSelected(newSelectedState);
        onSelectionChange(componentEndorsement, newSelectedState);
    };

    const columnsDataEndorsementsElevators = useMemo(() => {
        const commonColumns = (policy: string, component: string, insured: string | number, extraFields: any[]) => [
            { label: 'Póliza', value: policy, isLikeTitle: true, valueInBold: true },
            { label: 'Componente', value: component },
            ...extraFields,
            { 
                label: 'Endosar', 
                value: (
                    <Checkbox checked={selected} onChange={handleCheckboxChange}>
                        Seleccionar
                    </Checkbox>
                ),
            },
        ].map(col => ({ ...col, columnSize: { xs: { span: 12 }, sm: { span: 6 } } }));
    
        return type === ENDORSEMENTS_TYPES_VALUES.CALDERAS
            ? commonColumns(poliza, numeroComponente, nombreAsegurado, [
                { label: 'Asegurado', value: nombreAsegurado, valueInBold: true },
                { label: 'Suma Actual Calderas', value: renderCurrency(sumaAseguradaActualCalderas) },
                { label: 'Suma Nueva Calderas', value: renderCurrency(sumaAseguradaNuevaCalderas) },
                { label: 'Suma Actual Ascensores', value: renderCurrency(sumaAseguradaActualAscensores) },
                { label: 'Suma Nueva Ascensores', value: renderCurrency(sumaAseguradaNuevaAscensores) },
                { label: 'Fecha Fin de Vigencia', value: dayjs(finVigencia).format('DD/MM/YYYY') },
                { label: 'Prima Endoso', value: renderCurrency(prima) },
                { label: 'Premio Endoso', value: renderCurrency(premio) },
                { label: 'Comisión Monto', value: renderCurrency(comision) },
            ])
            : commonColumns(nroPoliza, nroComponente, -1, [
                { label: 'Marca Modelo/Año', value: `${marca} ${modelo}/${anio}` },
                { label: 'Suma Actual Vigente', value: renderCurrency(sumaActual) },
                { label: 'Suma INFO AUTO Mes en Curso', value: renderCurrency(sumaInfoAuto) },
                { label: 'Diferencia Monto', value: renderCurrency(diferenciaMonto) },
                { label: 'Diferencia Porcentaje', value: formattedPercentage(diferenciaPorcentaje) },
                { label: 'Fecha Próximo Vencimiento', value: dayjs(proximoVencimiento).format('DD/MM/YYYY') },
                { label: 'Prima Endoso', value: renderCurrency(prima) },
                { label: 'Premio Endoso', value: renderCurrency(premio) },
                { label: 'Comisión Monto', value: renderCurrency(comision) },
            ]);
    }, [
        type, poliza, numeroComponente, nombreAsegurado, sumaAseguradaActualCalderas, sumaAseguradaNuevaCalderas,
        sumaAseguradaActualAscensores, sumaAseguradaNuevaAscensores, finVigencia, prima, premio, comision,
        nroPoliza, nroComponente, marca, modelo, anio, sumaActual, sumaInfoAuto, diferenciaMonto, 
        diferenciaPorcentaje, proximoVencimiento, selected, handleCheckboxChange
    ]);
    

    return (
        <CardRender
            title={''}
            loading={loading}
            columnsData={columnsDataEndorsementsElevators}
        />
    );

}